//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Button,
  Cell,
  Collapse,
  CollapseItem,
  Icon,
  Popup,
  Search,
} from 'vant'
import { hyphenate } from '@/utils/transform'
import { isEvent } from '@/_utils'
import {
  debounce,
  set,
} from '@/utils/util'
import { cloneDeep } from '@/utils/lodash'
import CList from '../CList'
import CSmartTags from '../CSmartTags'
import CItem from '../CItem'
import { filterByLabelFormat } from '../../utils/translate'
import { isEmptyAll } from '../../utils/validator'

export default {
  components: {
    Search,
    CList,
    Popup,
    CSmartTags,
    Collapse,
    CollapseItem,
    CItem,
    Cell,
    Icon,
    CButton: Button,
  },

  props: {
    apiMethod: { type: Function },

    postMethod: { type: Function },

    methodConfig: {
      type: Object,
      default: () => ({}),
    },

    listChange: { type: Function },

    filterMethod: { type: Function },

    dataHook: { type: Function },

    dataPath: {
      type: String,

      // default: 'data',
      default: 'data.list',
    },

    model: {
      type: Object,
      default: () => ({}),
    },

    params: {
      type: Object,
      default: () => ({}),
    },

    placeholder: {
      type: String,
      default: '请输入搜索关键词',
    },

    renderData: {
      type: Array,
      default: () => ([
        {
          component: CSmartTags,
          title: '第一栏',
          value: 'test1',
          name: '1232',
          _close: () => {
            alert(23)
          },
        },
      ]),
    },

    immediate: {// 是否立即触发，改变查询时是否需要通过按钮触发
      type: Boolean,
      default: false,
    },

    auto: {// 是否自动查询
      type: Boolean,
      default: true,
    },

    showAction: {// 是否显示筛选按钮
      type: Boolean,
      default: false,
    },

    valueName: {
      type: String,
      default: 'key',
    },

    labelFormat: {
      type: String,
      default: '{name}',
    },

    listClass: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      pageNumber: 1,
      morePopupVisible: false,
      searchList: [],
      listParams: {},
      resultFlag: false,
      currentPageModel: {},
      innerPopupModel: {},
      activeNames: [0],
      handlerDiff: () => {},
    }
  },

  computed: {
    CSearchStyle () {
      if (this.auto || this.currentPageModel.searchKey) {
        return { height: '100%' }
      }
    },
  },

  watch: {
    model: {
      handler (val) {
        // if (!isEqual(this.innerPopupModel, val)) {
        this.renderData.forEach((el) => {
          set(el, 'postMethod', this.methodConfig, this.postMethod)
          if (val[el.value]) {
            set(val, el.value, val[el.value])
          }
        })

        this.currentPageModel = val
        this.innerPopupModel = {
          ...this.innerPopupModel,
          ...cloneDeep(val),
        }

        this.$emit('on-change', cloneDeep(val))

        // }
      },
      deep: true,
      immediate: true,
    },

    params: {
      handler (val) {
        if (!isEmptyAll(val)) {
          this.listParams = cloneDeep(val)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted () {
    this.handlerDiff = debounce(this.changeSearch, 500)
  },

  methods: {
    filterByLabelFormat,

    isEmptyAll,

    doSearch () {
      this.$emit('on-query', {
        ...this.innerPopupModel,
        ...this.currentPageModel,
      })
    },

    selectOneResult (item, list) {
      this.$emit('on-select', {
        value: item[this.valueName],
        label: this.filterByLabelFormat(item, this.labelFormat),
        row: item,
        data: list,
      })
    },

    async reset () {
      this.innerPopupModel = {}

      this.handlerModelChange()
      this.$emit('on-reset', {
        ...this.innerPopupModel,
        ...this.currentPageModel,
      })

      this.morePopupVisible = false

      await this.$nextTick()
      this._load()
    },

    handlerModelChange () {
      Object.keys(this.model).forEach((el) => {
        set(this.model, el, this.innerPopupModel[el])
        set(this.model, el, this.currentPageModel[el])
      })
    },

    async confirmChoose () {
      this.morePopupVisible = false

      this.handlerModelChange()
      await this.$nextTick()

      // let params = cloneDeep(this.currentPageModel)

      // if (this.filterMethod) { // 请求前请求参数过滤
      //   params = this.filterMethod(this.currentPageModel)
      // } else {
      //   this.$emit('on-query', {
      //     ...this.innerPopupModel,
      //     ...this.currentPageModel,
      //   })
      // }

      // this.listParams = {
      //   ...this.params,
      //   ...params,
      // }

      this._load()
    },

    async changeSearch (val) {
      if (!this.immediate) {
        return
      }

      this._load()
    },

    async _load () {
      let params = {
        ...this.params,
        ...this.currentPageModel,
        ...this.innerPopupModel,
      }

      if (this.filterMethod) { // 请求前请求参数过滤
        params = this.filterMethod(params)
      }

      this.listParams = { ...params }

      if (this.currentPageModel?.searchKey) {
        await this.$nextTick()
        this.$refs.list.reload()
      } else {
        if (this.auto) {
          await this.$nextTick()
          this.$refs.list.reload()
        }
      }
    },

    getComponentEvents (item) {
      const eventObj = {}

      Object.entries(item)
        .filter(([
          key,
          value,
        ]) => isEvent(key, value))
        .forEach(([
          key,
          value,
        ]) => {
          eventObj[hyphenate(key.slice(1))] = value
        })

      return eventObj
    },

    onChooseMore () {
      this.morePopupVisible = true
    },

    doExpend (item) {
      this.$set(item, 'expend', !item.expend)
    },
  },
}
